import { render, staticRenderFns } from "./ParticipantInfo.vue?vue&type=template&id=77aad1ec&scoped=true"
import script from "./ParticipantInfo.vue?vue&type=script&lang=js"
export * from "./ParticipantInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77aad1ec",
  null
  
)

export default component.exports